import { useMutation } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'

const useDeleteRestrictZone = () =>
  useMutation<void, Error, number>({
    mutationFn: MainApi.deleteRestrictZone,
  })

export default useDeleteRestrictZone
